import { QuickLookFilters } from '../types';

export const scheduleRelationshipsMetadata = {
  domain: 'autodesk-construction-schedule',
  type: 'activity',
};

export const weekOffsetMap = {
  [QuickLookFilters.THIS_WEEK]: 0,
  [QuickLookFilters.ONE_WEEK]: 1,
  [QuickLookFilters.TWO_WEEKS]: 2,
  [QuickLookFilters.THREE_WEEKS]: 3,
  [QuickLookFilters.FOUR_WEEKS]: 4,
  [QuickLookFilters.FIVE_WEEKS]: 5,
  [QuickLookFilters.SIX_WEEKS]: 6,
};

export const SCHEDULE_ANALYTICS = {
  ADD: 'schedule.activity.reference.add',
  DELETE: 'schedule.activity.reference.delete',
  VIEW: 'schedule.activity.reference.view',
};
